module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-41.ee69b18e.png";